import React from "react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { StringListEditor } from "./widgets.jsx";

// Friendly editor for the `drugs` collection. Exposes the clinically relevant
// fields as form controls; any other fields on the document (interactions,
// status, version, timestamps…) are preserved untouched via spread.

const TEXT = [
  ["name", "Drug name"],
  ["drug_class", "Drug class"],
  ["category", "Category"],
  ["route", "Route(s)"],
  ["frequency", "Frequency"],
  ["max_dose", "Max dose"],
  ["guideline_source", "Guideline source"],
];

const AREA = [
  ["indication", "Indication", 2],
  ["adult_dose", "Adult dose", 2],
  ["paediatric_dose", "Paediatric dose", 2],
  ["weight_based_calculation", "Weight-based calculation", 2],
  ["renal_adjustment", "Renal adjustment", 2],
  ["pregnancy_lactation", "Pregnancy / lactation", 2],
];

const LISTS = [
  ["contraindications", "Contraindications"],
  ["side_effects", "Side effects"],
  ["serious_side_effects", "Serious adverse effects"],
  ["monitoring", "Monitoring"],
  ["references", "References"],
];

export default function DrugForm({ value, onChange }) {
  const doc = value || {};
  const set = (k, v) => onChange({ ...doc, [k]: v });
  return (
    <div className="space-y-4" data-testid="drug-form">
      <div className="grid md:grid-cols-2 gap-3">
        {TEXT.map(([k, label]) => (
          <div key={k}>
            <Label className="text-xs">{label}</Label>
            <Input value={doc[k] ?? ""} onChange={(e) => set(k, e.target.value)} className="mt-1 text-sm" data-testid={`drugform-${k}`} />
          </div>
        ))}
      </div>
      {AREA.map(([k, label, rows]) => (
        <div key={k}>
          <Label className="text-xs">{label}</Label>
          <Textarea value={doc[k] ?? ""} onChange={(e) => set(k, e.target.value)} rows={rows} className="mt-1 text-sm" data-testid={`drugform-${k}`} />
        </div>
      ))}
      {LISTS.map(([k, label]) => (
        <div key={k}>
          <Label className="text-xs">{label}</Label>
          <div className="mt-1">
            <StringListEditor value={doc[k]} onChange={(v) => set(k, v)} placeholder={`Add a ${label.toLowerCase()} item…`} testid={`drugform-list-${k}`} />
          </div>
        </div>
      ))}
      <p className="text-[11px] text-slate-500 px-1">Drug interactions and other fields are preserved untouched. Saving locks this drug from the periodic sync.</p>
    </div>
  );
}
